import { Component,  OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkflowPageComponent } from '../base-classes/workflow-page/workflow-page.component';
import { Constants } from 'src/shared/utilities/constants.util';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { CostCenter } from 'src/shared/models/cost-center.model';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { HsgOidcManagerService,HsgUserProfile } from '@hhsg/hsg-asc';
import { from } from 'rxjs';

@Component({
    selector: 'smt-workflow-finish',
    templateUrl: './workflow-finish.component.html',
    styleUrls :['./workflow-finish.component.scss']
})

export class WorkflowFinishComponent extends WorkflowPageComponent implements OnInit {
   
   @Input() public costCenter: CostCenter;
   @Input() public shiftBlock: ShiftBlock;
   @Input() public workflowTime: string;
    
  public userInfo :HsgUserProfile;
    constructor(
        private _shiftBlockService: ShiftBlockService,
        private oidcManager: HsgOidcManagerService,
        private _router: Router) {
        super(_router);
    }

    ngOnInit() {   

        // this.oidcManager.getUserData().then((info)=>{
        //     this.userInfo = info;
        // }); 
        from(this.oidcManager.getUserData()).subscribe({
            next: (info) => {
                this.userInfo = info;
            },
            error: (error) => {
                console.error('Error getting user data:', error);
            }
        });
           
    }

     formattedShiftBlockRange() {
       if (!this.shiftBlock || !this.workflowTime) return '';

        return this._shiftBlockService.formatShiftTime(this.shiftBlock, this.workflowTime);
    }

     get listCostCenters() {
         return Constants.CostCenterWorkflowUrl;
     }

     get listShiftBlocks() {
         return '/workflow/shift-block/' + this.costCenter.id;
     }

    getWorkflowCompletedUserName() {
        if( this.userInfo)
        {
             return this.userInfo.firstName.trim() +' '+ this.userInfo.lastName.trim();
        }
       
    }
}
